import { Box, Typography } from '@mui/material';

interface BackupsetSectionCardProps {
  title: string;
  items: string[];
}

const BackupsetSectionCard = ({ title, items }: BackupsetSectionCardProps) => (
  <Box
    sx={{
      borderRadius: '4px',
      overflow: 'hidden',
      border: '1px solid #E2E8F0',
    }}
  >
    {/* Section header */}
    <Box
      sx={{
        backgroundColor: '#555555',
        padding: '4px 10px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '11px',
          lineHeight: '16px',
          color: '#FFFFFF',
        }}
      >
        {title}
      </Typography>
    </Box>

    {/* Section rows */}
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {items.length === 0 && (
        <Box
          sx={{
            padding: '4px 10px',
            backgroundColor: '#F9FAFB',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '11px',
              lineHeight: '16px',
              color: '#94A3B8',
            }}
          >
            No items configured.
          </Typography>
        </Box>
      )}

      {items.map((item, index) => {
        const sameBefore = items.slice(0, index).filter((x) => x === item).length;
        return (
          <Box
            key={`${title}:${item}:${sameBefore}`}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              padding: '3px 10px',
              gap: '8px',
              backgroundColor: index % 2 === 0 ? '#F3F3F3' : '#E5E5E5',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 600,
                fontSize: '11px',
                lineHeight: '16px',
                color: '#64748B',
                minWidth: '28px',
              }}
            >
              {index + 1}:
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 600,
                fontSize: '12px',
                lineHeight: '18px',
                color: '#0F172A',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {item}
            </Typography>
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default BackupsetSectionCard;

